import React from 'react';
import {DropDown} from 'MWC';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
      termsData = {
          6: {
              value: 6,
              text: 'CALCULATOR_FULL_MONTHS'
          },
          12: {
              value: 1,
              text: 'CALCULATOR_YEAR'
          },
          24: {
              value: 2,
              text: 'CALCULATOR_YEARS'
          },
          36: {
              value: 3,
              text: 'CALCULATOR_YEARS'
          },
          60: {
              value: 5,
              text: 'CALCULATOR_YEARS_01'
          }
      },
    terms = model.getTerms().map((item, index) => {
        return (
          <button className={`term-btn ${index === Number(model.getCurrentLoanTerm()) ? 'active' : ''}`} name="loanTerm" key={item} onClick={calc.handleChange} value={index}>
              {termsData[item].value} {calc.l10n(termsData[item].text)}
          </button>
        )
    }),
    sumOrient = (
      <>
          <div>{(model.getMinSumEdge()).toLocaleString('uk-UA') + ' ' + calc.l10n('UAH_ICON')}</div>
          <div>{(model.getMaxSumEdge() / 2).toLocaleString('uk-UA') + ' ' + calc.l10n('UAH_ICON')}</div>
          <div>{(model.getMaxSumEdge()).toLocaleString('uk-UA') + ' ' + calc.l10n('UAH_ICON')}</div>
      </>
        ),
    selectOptions = [
        (<div key="5" value="loyal_schema_five">{calc.l10n("CREDIT_QUICK_CASH_SCHEMA_5")}</div>),
        (<div key="4" value="loyal_schema_four">{calc.l10n("CREDIT_QUICK_CASH_SCHEMA_4")}</div>),
        (<div key="1" value="loyal_schema_one">{calc.l10n("CREDIT_QUICK_CASH_SCHEMA_1")}</div>),
        (<div key="2" value="loyal_schema_two">{calc.l10n("CREDIT_QUICK_CASH_SCHEMA_2")}</div>),
        (<div key="3" value="loyal_schema_three">{calc.l10n("CREDIT_QUICK_CASH_SCHEMA_3")}</div>),
    ],
      starInfo = calc.state.model.selectedType === 'loyal_schema_one' || calc.state.model.selectedType === 'loyal_schema_four' || calc.state.model.selectedType === 'loyal_schema_five' ? (
          <div className='star-info'>{calc.l10n("CREDIT_QUICK_CASH_CALCULATOR_STAR_INFO")}</div>
        )
        : '',
      hintInfo =  calc.state.model.selectedType === 'loyal_schema_five' ? (
        <div className='star-info' dangerouslySetInnerHTML={{__html: calc.l10n("CREDIT_QUICK_CASH_CALCULATOR_HINT_INFO")}}></div>
      )
        : '';
    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <div className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</div>
                  <div className="calc-mode-description">
                    {calc.l10n("CREDIT_QUICK_CASH_SCHEMA_TEXT")}
                    <DropDown className="metal-alloy-controller type-selector"
                              name="selectedType"
                              value={model.getCalculatorType()}
                              onChange={calc.handleChange}
                              collection={selectOptions}
                              min={model.getMinSumEdge()}
                              max={model.getMaxSumEdge()}
                    />
                  </div>
                  {hintInfo}
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CREDIT_QUICK_CASH_SUM')}
                    </div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="creditSum" type="text"
                                   className="calculator-slider-value"
                                   value={model.getCreditSum().toLocaleString('uk-UA')}
                                   onChange={calc.handleChangeInput}
                                   onBlur={calc.blurChangeInput}
                                   max={model.getMaxSumEdge()}
                                   min={model.getMinSumEdge()}>
                            </input>
                          <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
                          <span style={{left: `${calc.state.valueWith + 10}px`}}>{calc.l10n('UAH_ICON')}</span>
                        </div>
                        <input type="range"
                            name="creditSum"
                            className="calculator-sum-slide"
                            onChange={calc.handleChange}
                            value={model.getCreditSum()}
                            min={model.getMinSumEdge()}
                            max={model.getMaxSumEdge()}
                            step={model.getSumStep()}
                            style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent}%)`}}
                        />
                    </div>
                    <div className="calculator-slider-orient">
                        {sumOrient}
                    </div>
                </div>
                <div className="controller-block terms">
                    <div className="calc-block-title">
                        {calc.l10n('CREDIT_QUICK_CASH_TERM')}
                    </div>
                    <div className="calculator-terms-wrapper">
                        {terms}
                    </div>
                  {/* {starInfo} */}
                </div>
            </div>
        </React.Fragment>
    );
}
